var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleGrayCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8291_13388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8291_13388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1333 22.1334L23.5333 12.7334L21.6666 10.8667L14.1333 18.4001L10.3333 14.6001L8.46663 16.4667L14.1333 22.1334ZM16 29.3334C14.1555 29.3334 12.4222 28.9832 10.8 28.2827C9.17774 27.5832 7.76663 26.6334 6.56663 25.4334C5.36663 24.2334 4.41685 22.8223 3.71729 21.2001C3.01685 19.5779 2.66663 17.8445 2.66663 16.0001C2.66663 14.1556 3.01685 12.4223 3.71729 10.8001C4.41685 9.17786 5.36663 7.76675 6.56663 6.56675C7.76663 5.36675 9.17774 4.41653 10.8 3.71608C12.4222 3.01653 14.1555 2.66675 16 2.66675C17.8444 2.66675 19.5777 3.01653 21.2 3.71608C22.8222 4.41653 24.2333 5.36675 25.4333 6.56675C26.6333 7.76675 27.5831 9.17786 28.2826 10.8001C28.9831 12.4223 29.3333 14.1556 29.3333 16.0001C29.3333 17.8445 28.9831 19.5779 28.2826 21.2001C27.5831 22.8223 26.6333 24.2334 25.4333 25.4334C24.2333 26.6334 22.8222 27.5832 21.2 28.2827C19.5777 28.9832 17.8444 29.3334 16 29.3334Z",
    fill: "#E1E4EB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGrayCheck);
export default __webpack_public_path__ + "static/media/circle_gray_check.c783f8f1e3e3d590b6a49a4f5933bf8d.svg";
export { ForwardRef as ReactComponent };